import { addCart } from "../utils/addCart";
import json from "../utils/json";

type AddToCartParams = {
  items: {
    id: string | number;
    properties?: {
      [key: string]: string | number;
    };
    quantity: string | number;
  }[];
};

type ProductData = {
  id: string | number;
  properties?: {
    [key: string]: string | number;
  };
  quantity: string | number;
};

export default class AddToCart extends HTMLElement {
  constructor() {
    super();
    const $el = this as HTMLElement;
    $el.addEventListener("click", async () => {
      if ($el.hasAttribute("disabled")) return;

      const addToCartParams: AddToCartParams = {
        items: [],
      };

      for (let i = 0; ; i += 1) {
        const index = i + 1;
        const addtocartId = $el.dataset[`addtocartId${index}`];
        const addtocartQty = $el.dataset[`addtocartQty${index}`];
        const addtocartProp = $el.dataset[`addtocartProp${index}`];

        if (!addtocartId) {
          break;
        }

        const productQty = addtocartQty ? parseInt(addtocartQty, 10) : 1;

        // build product object
        const productData: ProductData = {
          id: parseInt(addtocartId, 10),
          quantity: productQty,
        };

        if (addtocartProp && addtocartProp.length > 0) {
          productData.properties = json(addtocartProp);
        }

        console.log(productData);
        // push product object to global array
        addToCartParams.items.push(productData);
      }

      // add products to cart

      $el.classList.add("is-loading");
      await addCart(addToCartParams);
      const $openCart =
        document.querySelector<HTMLButtonElement>(".header-icon__cart");
      $openCart?.click();
      update_cart(function () {
        // dispatch update event
        var event = document.createEvent("Event");
        event.initEvent("updated_cart", true, true);
        document.dispatchEvent(event);
        // dispatch add to cart event
        var event_atc = document.createEvent("Event");
        event_atc.initEvent("added_to_cart", true, true);
        document.dispatchEvent(event_atc);
      });
      $el.classList.remove("is-loading");
    });
  }
}
